export default [
    {
        path: 'relatorio-producao-ambulatorial',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-relatorio-producao-ambulatorial' */
            '@/views/ambulatorio/relatorio-producao-ambulatorial/Index'
        ),
        redirect: 'relatorio-producao-ambulatorial/index',
        children: [
            {
                name: 'ambulatorio-relatorio-producao-ambulatorial-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-relatorio-producao-ambulatorial' */
                    '@/views/ambulatorio/relatorio-producao-ambulatorial/List.vue'
                ),
            },
        ],
    },
]